class BritishColumbiaObstetricalFilePartnerInformation {
    public FullName: string = "";
    public Occupation: string = "";
    public IsBiologicialFatherSameAsPartner: boolean = false;
    public BiologicalFatherFullName: string = "";
    public BiologicalFatherAge: number;
    public BiologicalFatherEthnicity: string = "";

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePartnerInformation>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFilePartnerInformation };
